import { createContext } from 'react';

import type { SourceAccountsContextValue } from './sourceAccountsContextTypes';

export const SourceAccountsContext =
  createContext<SourceAccountsContextValue | null>(null);
